import {Injectable} from '@angular/core';
import {CashierContentService} from 'src/app/services/cashier/cashier-content.service';
import {CashierService} from 'src/app/services/cashier/cashier.service';
import {Navigator} from 'src/app/components/menu/navigator';
import {UtilsService} from '../utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class OnDepositService {
  constructor(
    private navigator: Navigator,
    private utils: UtilsService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService
  ) {}
  deposit(campaignId) {
    return this.cashierService
      .getActiveTypesCategories({include_types: false})
      .subscribe(
        (response: any) => {
          if (response) {
            const navParams: any = {};
            const data = response.payload.filter(
              item => item.is_default == true
            );
            const lastDeposit = data.length > 0 ? data[0].code : null;
            const pageToRedirect =
              this.cashierContentService.getVendorPage(lastDeposit);
            const recievedSelectedBonus =
              this.cashierContentService.getSelectedBonus();
            if (campaignId) {
              this.utils.setCampaignId(campaignId);
              this.cashierContentService.setSelectBestOne(false);
              navParams.bonusCode = campaignId;
            } else {
              if (recievedSelectedBonus) {
                this.cashierContentService.setSelectBestOne(true);
                navParams.bonusCode = recievedSelectedBonus.offer.campaign_code;
              }
            }

            pageToRedirect
              ? this.navigator.navigateTo(
                  pageToRedirect,
                  {multipleModals: true},
                  navParams
                )
              : this.navigator.navigateTo(
                  'DepositMainComponent',
                  {multipleModals: true},
                  navParams
                );
          }
        },
        error => this.navigator.navigateTo('DepositMainComponent')
      );
  }
}
